import React, { useState, useEffect , useRef} from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const DepartmentModal = ({ onSubmit, departmentData }) => {
  const [departmentName, setDepartmentName] = useState("");
  const [departmentNameError, setDepartmentNameError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const submitButtonRef = useRef(null);


const apiUrl = process.env.REACT_APP_API_URL;
const token = localStorage.getItem("token");

useEffect(() => {
  // If departmentData is provided (edit mode), populate the form fields
  if (departmentData) {
    setDepartmentName(departmentData.department); // Assuming `department` is the correct field name
    setDepartmentNameError(""); // Clear the error message if the input is valid

  } else {
    // If departmentData is not provided, set departmentName to null
    setDepartmentName("");
    setDepartmentNameError(""); // Clear the error message if the input is valid
  }
}, [departmentData]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate departmentName
    if (!departmentName || !departmentName.trim()) {    // If departmentName is empty or contains only whitespace characters
      setDepartmentNameError("Department Name is required");
      return; // Exit early if validation fails
  
    }

    // Check if departmentName exceeds maximum length (100 characters)
    if (departmentName.trim().length > 80) {
      setDepartmentNameError("Department Name must not exceed 80 characters");
      return; // Exit early if validation fails
    }

    try {
      let response;
      if (departmentData) {
        // Edit existing department
        response = await axios.put(
          `${apiUrl}/departments/update/${departmentData.id}`,
          {
            department: departmentName,
            date: new Date().toISOString(),
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success("Department updated successfully!");

      } else {
        // Add new department
        response = await axios.post(
          `${apiUrl}/departments/add`,
          {
            department: departmentName,
            date: new Date().toISOString(),
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success("Department added successfully!");
      }

      // Call the onSubmit function passed from parent with response data
          // Extract the department object from the response
          const updatedDepartment = response;

          // Call the onSubmit function passed from the parent with the updated department
          onSubmit(updatedDepartment);

          if (submitButtonRef.current) {
            submitButtonRef.current.click(); // Trigger the click event
          }
      // Reset form fields and errors
      setDepartmentName("");
      setDepartmentNameError("");
    } catch (error) {
      let errorMessage = "Failed to perform the operation. Please try again later.";
      if (error.response && error.response.data && error.response.data.error) {
        errorMessage = error.response.data.error;
      }
      toast.error(errorMessage);
    }
  };




  const handleChange = (e) => {
    const { value } = e.target;
    setDepartmentName(value);

    // Validate departmentName when the input value changes
    if (!value.trim()) {
      setDepartmentNameError("Department Name is required");
    } else {
      setDepartmentNameError(""); // Clear the error message if the input is valid
    }
  };

  return (
    <>
      {/* Department Modal */}
      <div
  id="add_department"
  className={`modal custom-modal fade ${showModal ? "show" : ""}`}
  role="dialog"
>
  <div
    className="modal-dialog modal-lg"
    style={{
      margin: 0,
      position: "fixed",
      right: 0,
      height: "100vh",
      width: "40%",
    }}
  >
    <div className="modal-content h-100">
      <div className="modal-header">
        <h5 className="modal-title">
          {departmentData ? "Edit Department" : "Add Department"}
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          onClick={() => setShowModal(false)}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div
        className="modal-body"
        style={{ maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}
      >
        <div className="form-group row mb-3">
          <label className="col-md-4 col-form-label">
            Department Name <span className="text-danger">*</span>
          </label>
          <div className="col-md-8">
            <input
              type="text"
              className={`form-control ${
                departmentNameError && "is-invalid"
              }`}
              value={departmentName}
              onChange={handleChange}
              name="departmentName"
            />
            {departmentNameError && (
              <div className="invalid-feedback">{departmentNameError}</div>
            )}
          </div>
        </div>
        <hr style={{ border: "0.5px solid #ddd" }} /> {/* Light horizontal line */}
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button
          type="submit"
          onClick={handleSubmit}
          className="btn btn-primary"
        >
          {departmentData ? "Save Changes" : "Save"}
        </button>

        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          aria-label="Close"
          type="reset"
          onClick={() => setShowModal(false)}
        >
          Cancel
        </button>
      </div>

      <div style={{ display: "none" }}>
        <button
          ref={submitButtonRef}
          data-bs-dismiss="modal"
          aria-label="Close"
          type="reset"
        >
          Submit2
        </button>
      </div>
    </div>
  </div>
</div>


      {/* /Department Modal */}
    </>
  );
};

export default DepartmentModal;
